// this allows 5 digits
export const validZipCodeRegex = new RegExp('^\\d{5}$');
// this allows a partial zip code 5 or less digits
export const validPartialZipCodeRegex = new RegExp('^\\d{0,5}$');
export const onlyNumbersRegex = new RegExp('^[0-9]+$');
export const isLowercaseAlphaNumeric = new RegExp('^[a-z0-9]*$');

export const REGEX_PARSE_PHONE = /[^\d*+#]/g;
export const REGEX_NON_DIGITS = /\D/g;
export const REGEX_PHONE_PATTERN = /(\d{3})(\d{3})(\d{4})$/;

export const isValidZipCode = (zipCode: string) => {
  return validZipCodeRegex.test(zipCode);
};

export const isOnlyNumbers = (string: string) => {
  return onlyNumbersRegex.test(string);
};

export const isLowercaseOrNumber = (string: string) => {
  return isLowercaseAlphaNumeric.test(string);
};

// check if not null, less than 5 digits
export const isIncompleteZip = (zipCode: string) => {
  return zipCode.length > 0 && zipCode.length < 5;
};
